import React from "react";
import CardHeader from "../../../../Universal/CardHeader.component";
import DonutChart from "../../../../Universal/DonutChart.component";
import SelectFilter from "../../../UniversalComponents/SelectFilter.component";
import ScrollableCardTable from "../../../../Universal/ScrollableCardTable.component";

const CashOutFlowPieChartTwo = ({ donutChartData }) => {
  return (
    <div style={{ padding: "1rem" }} className="viewPollingDetailsContainer">
      <CardHeader
        title="Charity"
        actionBtn={<SelectFilter />}
        headerStyle={{ borderBottom: "none" }}
      />
      <div className="flex-row g-05 space-between w-full h-half flex-1">
        <div className="h-full w-half">
          <DonutChart
            data={donutChartData}
            title="Total expenses in market"
            valuemapKey="percentage"
          />
        </div>

        <div className="w-half h-full flex-col align-start justify-start">
          <ScrollableCardTable thead={["Categories", "Contribution(%)"]}>
            {donutChartData &&
              donutChartData.map((_data, index) => {
                return (
                  <tr
                    style={{
                      "--pollingDonutChartTableDetailsIndicatorColor":
                        _data.positionColor,
                    }}
                    className="pollingDetailsTableData w-full flex-row align-center justify-arround"
                  >
                    <td
                      style={{
                        width: `calc(100%/${3})`,
                        textAlign: "center",
                      }}
                    >
                      {_data.category}
                    </td>
                    {/* <td
                      style={{
                        width: `calc(100%/${3})`,
                        textAlign: "center",
                      }}
                    >
                      {_data.appearanceCount}
                    </td> */}
                    <td
                      style={{
                        width: `calc(100%/${3})`,
                        textAlign: "center",
                      }}
                    >
                      {_data.percentage} %
                    </td>
                  </tr>
                );
              })}
          </ScrollableCardTable>
        </div>
      </div>
      <div className="bottom-text">
        <div className="">
          Approx 32 students are beneficial due to{" "}
          <span style={{ color: "var(--blueColor1)" }}>
            scholarships & fee waivers
          </span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
          className="total"
        >
          <span style={{ color: "var(--successGreen)" }}>
            Total beneficial amount
          </span>
          <span style={{ color: "var(--grayColor)", fontSize: "larger" }}>
            ₹ 25,00,000
          </span>
        </div>
      </div>
    </div>
  );
};

export default CashOutFlowPieChartTwo;
